import { render, staticRenderFns } from "./UsersList.vue?vue&type=template&id=1796faee"
import script from "./UsersList.vue?vue&type=script&lang=js"
export * from "./UsersList.vue?vue&type=script&lang=js"
import style0 from "./UsersList.vue?vue&type=style&index=0&id=1796faee&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports